module.exports = {
          srcSet: __webpack_public_path__ + "835ef1003263a7f8c028b16a862b5db8-751.png"+" 751w",
          images:[ {path: __webpack_public_path__ + "835ef1003263a7f8c028b16a862b5db8-751.png",width: 751,height: 421}],
          src: __webpack_public_path__ + "835ef1003263a7f8c028b16a862b5db8-751.png",
          toString:function(){return __webpack_public_path__ + "835ef1003263a7f8c028b16a862b5db8-751.png"},
          
          width: 751,
          height: 421
        }